import type { DeviceInfo } from '@innogy/shared/responsive-tools';
import { createAction, props } from '@ngrx/store';

export const initOrderCrossSell = createAction(
  '[become-a-customer-order] Init cross-sell',
  props<{ deviceInfo: DeviceInfo; thuisvoordeelAddonEnabled: boolean }>()
);

export const orderCrossSellEnabled = createAction(
  '[become-a-customer-order] Enable cross-sell',
  props<{ enabled: boolean; isCustomerTypeEnabled: boolean }>()
);
